import * as Sentry from '@sentry/react';
import React, { ReactNode } from 'react';

interface SentryErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Sentry Error Boundary component for React
 */
export const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ children, fallback }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={fallback as React.ReactElement | undefined}
      beforeCapture={(scope, _error, _hint) => {
        scope.setTag('component', 'error-boundary');
        scope.setLevel('fatal');
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
